import * as Yup from "yup"
import AdditionalFieldOptionContent from "./AdditionalFieldOptionContent";

export default class AdditionalFieldOption {
    id;
    used = false;

    constructor() {
        this.contents = new AdditionalFieldOptionContent();
    }

    static schema = (settings) => {
        let fields = {
            label: Yup.string().required('CMS.Modules.AdditionalField.Options.Content.Form.label').max(100, 'CMS.Modules.AdditionalField.Options.Content.Form.label|100|max'),
        };

        return Yup.object(fields);
    }

    static fromJson = (json) => {
        let item = new AdditionalFieldOption();

        item.id = json.id;
        item.used = json.used;

        item.contents = json.contents.map(content => AdditionalFieldOptionContent.fromJson(content));

        return item;
    }
}
